module.exports = __webpack_public_path__ + "static/img/media-bar-ON-36px.52bb71cb.png";